
export default (axios) => ({
  getPreServiceBillsData(queryString) {
    return axios.get("/pre_service_bills", {
      params: queryString
    })
  }
})